import { SVGProps } from 'react';

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="185"
      height="185"
      viewBox="0 0 185 185"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path
        d="M185 185H0V0C49.065 0 96.1206 19.491 130.815 54.1852C165.509 88.8795 185 135.935 185 185Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComponent;
